<div class="frac-home-hse-requirements">
  <sa-lmo-frac-home-card *ngIf="frac" localStorageKey="home__hse_requirements">
    <header class="my-1 py-2">
      <img src="/assets/icons/hse.svg" alt="SANDi Lite" />
      <span class="text-xl font-medium">Health, Safety and Environment</span>
    </header>
    <main>
      <section class="info-panel">
        <div class="status">{{ hseRequirements }}</div>
        <div class="name upper">requirements</div>
      </section>
    </main>
  </sa-lmo-frac-home-card>
</div>
